const BE_URL = process.env.REACT_APP_BE_URL;

module.exports = {
  baseUrl: `${BE_URL}/api/total/supporters/`
};
